import React from "react";
import { Container, Typography, Button, Stack } from "@mui/material";

const Simulations2 = ({ setView }) => {
	  const buttons = [
		      { label: "Scenario 1: Empathetic Response & Patience", view: "training", variant: "contained" },
		      { label: "Scenario 2: Sundowning", view: "training" },
		      { label: "Scenario 3: Waking up", view: "training" },
		      { label: "Scenario 4: Difficult Public Situation", view: "training" },
		    ];

	  return (
		      <Container maxWidth="md" sx={{ mt: 4 }}>
		        <Typography variant="h4" gutterBottom>
		          Training Simulations
		        </Typography>
		        <Stack spacing={2}>
		          {buttons.map(({ label, view, variant }) => (
				            <Button
				              key={view}
				              variant={variant || "text"}
				              onClick={() => setView(view)}
				            >
				              {label}
				            </Button>
				          ))}
		        </Stack>
		      </Container>
		    );
};

export default Simulations2;

